import React, { useState } from "react";
import DashboardUserCell from "../../ui/compoP/DashboardUserCell";
import SvgIcn from "../../data/IconCompo";

const UsersTable = ({ users, handleMessageClick, handleDeleteUserClick }) => {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (columnName) => {
    if (sortConfig.key !== columnName) {
      return <SvgIcn name="sort" className="sort-icon" />;
    }
    return sortConfig.direction === "ascending" ? (
      <SvgIcn name="sort_up" className="sort-icon active" />
    ) : (
      <SvgIcn name="sort_down" className="sort-icon active" />
    );
  };

  const getSortedUsers = () => {
    if (!sortConfig.key) return users;

    return [...users].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle special cases
      switch (sortConfig.key) {
        case "name":
          aValue = a.fullName?.toLowerCase() || "";
          bValue = b.fullName?.toLowerCase() || "";
          break;
        case "role":
          aValue = (a.sub_role || "User").toLowerCase();
          bValue = (b.sub_role || "User").toLowerCase();
          break;
        case "joined":
          aValue = new Date(a.joinedDate).getTime();
          bValue = new Date(b.joinedDate).getTime();
          break;
        case "lastAccess":
          aValue = new Date(a.last_access || a.createdAt).getTime();
          bValue = new Date(b.last_access || b.createdAt).getTime();
          break;
        case "favs":
          aValue = Number(a.favs || 0);
          bValue = Number(b.favs || 0);
          break;
        case "clicks":
          aValue = Number(a.clicks || 0);
          bValue = Number(b.clicks || 0);
          break;
        default:
          if (typeof aValue === "string") {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }
      }

      if (aValue < bValue) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  const sortedUsers = getSortedUsers();

  return (
    <>
      <div className="btns-items-box">
        <div className="header-item">User</div>
        <div className="header-item">Loc</div>
        <div className="header-item">Photo</div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("name")}
        >
          Name {getSortIcon("name")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("username")}
        >
          Username {getSortIcon("username")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("role")}
        >
          Role {getSortIcon("role")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("favs")}
        >
          Favs {getSortIcon("favs")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("clicks")}
        >
          Click {getSortIcon("clicks")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("joined")}
        >
          Joined {getSortIcon("joined")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("lastAccess")}
        >
          Access {getSortIcon("lastAccess")}
        </div>
        <div className="header-item">Actions</div>
      </div>

      <div className="users-content">
        {sortedUsers.map((user, index) => (
          <DashboardUserCell
            key={index}
            uxerIcon={user.uxerIcon || "user"}
            name={user.fullName}
            username={user.username}
            role={user.sub_role || "User"}
            favs={user.favs || "0"}
            clicks={user.clicks || "0"}
            image={user.image}
            joinedDate={new Date(user.joinedDate).toLocaleDateString()}
            lastAccess={new Date(
              user.last_access || user.createdAt
            ).toLocaleDateString()}
            onMessageClick={() => handleMessageClick(user.username)}
            onDeleteClick={() => handleDeleteUserClick(user)}
            userId={user._id}
            user={user}
            nationality={user.nationality}
          />
        ))}
      </div>
    </>
  );
};

export default UsersTable;
